import { post } from '@/utils/request'

/**
 * 支付宝账号第三方授权(前台获得gourl后，跳过去，后面就会进入授权流程)
 */
export default function taoke_alipay_auth(data) {
  return post('taoke_alipay_auth', data)
}